import React, {Component} from 'react';
import { InputItem, List, NavBar, Checkbox, Picker, Toast,Button,Modal} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import Upload from 'rc-upload';
import {idcardUpload ,walletOpen,walletScode,walletScodeSend} from "../../../service/homeService";
import storage from "../../../utils/localStore";
import WalletModal from "../../../components/WalletModal";
const CheckboxItem = Checkbox.CheckboxItem;
const sfzz = require('../../../common/image/sfzz.png');
const sfzf = require('../../../common/image/sfzf.png');
const colors = [
    {label: '公务员', value: 1,},
    {label: '事业单位员工', value: 2,},
    {label: '公司员工', value: 3,},
    {label: '军人警察', value: 4,},
    {label: '工人', value: 5,},
    {label: '农民', value: 6,},
    {label: '管理人员', value: 7,},
    {label: '技术人员', value: 8,},
    {label: '私营业主', value: 9,},
    {label: '文体明星', value: 10,},
    {label: '自由职业者', value: 11,},
    {label: '学生', value: 12,},
];
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Wallet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName:"",
            cardNum:"",
            bankCard:"",
            phone:"",
            occupation:"",
            protocolVal:false,
            imageUrl:"",
            sfzzUrl:"",
            code:'',
            getCodeDisabled: false,
            getCodeText: '获取验证码',
            fileBase64:"",
            fileData:"",

            validity: [
                {value: 0, label: '是'},
                {value: 1, label: '否'},
            ],
            validityVal:"",
            date:"",
            accountData:"",
            dataFlag:false,
            walletModal:false,
        };
    }
    // 开户，验证验证码
    submit(){
        if (this.state.code == "") {
            Toast.fail('请输入验证码', 2);
            return
        }
        if(this.state.accountData !== ""){
            Toast.loading('',0);
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    corpSerno:this.state.accountData.corpSerno,
                    smsSendNo:this.state.accountData.smsSendNo,
                    smsCode:this.state.code,
                },
            };
            walletScode(params).then((res)=>{
                if(res.data.code === '0000'){
                    let usr = {
                        token:this.props.userInfo.token,
                        phone: this.props.userInfo.phone,
                        openid: this.props.userInfo.openid,
                        nickname:this.props.userInfo.nickname,
                        avatar:this.props.userInfo.avatar,
                        integral:this.props.userInfo.integral,
                        emergencyContact:this.props.userInfo.emergencyContact,
                        idNum:this.props.userInfo.idNum,
                        userId:this.props.userInfo.id,
                        walletStatus:res.data.data.status,
                    };
                    storage.setItem('usr', usr);
                    if(res.data.data.status == 1){
                        return Modal.alert('受理成功', '尊贵的民途出行会员，您的民途出行电子钱包受理中！打开钱包首页点击右上角【账户签约】完成签约，即可体验完整电子钱包功能（包括订单快捷支付等）', [
                            { text: '知道了',onPress: () => this.props.history.goBack()},
                        ]);
                    }
                    if(res.data.data.status == 2){
                        Toast.info("开户失败,请检查信息是否正确",2,);
                    }
                    if(res.data.data.status == 3){
                        return Modal.alert('开户成功', '尊贵的民途出行会员，您的民途出行电子钱包受理中！打开钱包首页点击右上角【账户签约】完成签约，即可体验完整电子钱包功能（包括订单快捷支付等）', [
                            { text: '知道了',onPress: () => this.props.history.goBack()},
                        ]);
                    }
                }else{
                    Toast.info(res.data.msg,3);
                    this.setState({ataFlag:true})
                }
            });
        }
    };
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后重新获取'});
            } else {
                this.setState({getCodeText: '获取验证码'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    changeTime = (value, key) => {
        this.setState({[key]: value,});
    };
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
        console.log(e.target.checked);
    };
    getCode(){
        const {userName,cardNum,bankCard,phone,occupation,imageUrl,sfzzUrl,protocolVal,accountData}=this.state;
        if(accountData == ""){
            // if(imageUrl == "" || sfzzUrl == ""){
            //     Toast.info("请上传身份证");
            //     return
            // }
            if(userName == ""){
                Toast.info("请输入姓名");
                return
            }
            if(cardNum == ""){
                Toast.info("请输入证件号码");
                return
            }
            if(bankCard == ""){
                Toast.info("请输入银行卡号");
                return
            }
            if(phone === ""){
                Toast.info("请输入手机号码");
                return
            }
            if (!phoneReg.test(phone.replace(/\s/ig, ''))) {
                Toast.fail('请输入正确的手机号', 2);
                return
            }
            if(occupation == ""){
                Toast.info("请选择职业");
                return
            }
            if(protocolVal === false){
                Toast.info("请同意账户开通协议");
                return
            }
            return Modal.alert('提示',"请确认信息，提交后如需更改请刷新页面重新填写信息", [
                { text: '返回编辑',},
                { text: '确认', onPress: () => {
                    Toast.loading('',0);
                    let params = {
                        source:1,
                        token:this.props.userInfo.token,
                        data:{
                            name:userName,
                            idNumber:cardNum,
                            bankNumber:bankCard,
                            phone:phone,
                            profession:occupation.toString(),
                        },
                    };
                    walletOpen(params).then((res)=>{
                        if(res.data.code === '0000'){
                            Toast.hide();
                            this.setDownTime(60);
                            this.setState({accountData:res.data.data,dataFlag:true})
                        }else{
                            this.setState({getCodeDisabled: false,});
                            Toast.info(res.data.msg,3);
                        }
                    });
                } },
            ]);
        }else{
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    corpSerno:accountData.corpSerno,
                },
            };
            walletScodeSend(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.hide();
                    this.setDownTime(60);
                    this.setState({accountData:res.data.data})
                }else{
                    this.setState({getCodeDisabled: false,});
                    Toast.info(res.data.msg,3);
                }
            });
        }

    }
    componentDidMount(){}
    beforeUpload=(file)=> {
        console.log('beforeUpload', file);
        let fileBase64 = "";
        return new Promise((resolve, reject) => {
            // 对文件的信息进行 类型判断
            console.log(resolve, reject);
            let index = file.name.lastIndexOf('.');
            // if (file.name.slice(index) !== ".jpg") {
            //     Toast.info("请上传jpg格式");
            //     reject("请上传jpg格式");
            //     return
            // }
            if(file.size/1024 > 8192){
                Toast.info("上传文件的大小不能超过8M");
                reject("上传文件的大小不能超过8M");
                return
            }
            let r = new window.FileReader();
            r.readAsDataURL(file);
            r.onload = (e)=>{
                this.cutImageBase64(e.target.result,500,(base64 )=>{console.log(base64.length/1024);this.setState({fileData:base64});});
            };
            setTimeout(() => {
                resolve(file);
            }, 1000);
            // resolve(file);
        })
    };
    cutImageBase64(base64, w, callback) {
        let newImage = new Image();
        let quality = 0.6;    //压缩系数0-1之间
        newImage.src = base64;
        newImage.setAttribute("crossOrigin", 'Anonymous');  //url为外域时需要
        let imgWidth, imgHeight;
        newImage.onload = function () {
            imgWidth = this.width;
            imgHeight = this.height;
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            if (Math.max(imgWidth, imgHeight) > w) {
                if (imgWidth > imgHeight) {
                    canvas.width = w;
                    canvas.height = w * imgHeight / imgWidth;
                } else {
                    canvas.height = w;
                    canvas.width = w * imgWidth / imgHeight;
                }
            } else {
                canvas.width = imgWidth;
                canvas.height = imgHeight;
                quality = 0.6;
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
            let base64 = canvas.toDataURL("image/jpg", quality); //压缩语句
            // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
            while (base64.length / 1024 > 500) {
                quality -= 0.01;
                base64 = canvas.toDataURL("image/jpg", quality);
            }
            // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
            while (base64.length / 1024 < 50) {
                quality += 0.001;
                base64 = canvas.toDataURL("image/jpg", quality);
            }
            callback(base64);//必须通过回调函数返回，否则无法及时拿到该值
        }
    }
    transformFile=(file) =>{
        return new Promise(resolve => {
            file = ""
            // let r = new window.FileReader();
            // r.readAsDataURL(file);
            // r.onload = (e)=>{
            //     file = e.target.result;
            // };
            setTimeout(() => {
                resolve(file);
            }, 1000);
            console.log(file)
        });
    };
    onStart=(file) => {
        console.log('onStart', file.name);
        Toast.loading("正在上传",0)
    };
    renxiangCustom = (request) => {
        idcardUpload(request.data).then((res)=>{
            console.log(res);
            if(res.data.code == "0000"){
                this.setState({imageUrl:res.data.data.url,userName:res.data.data.name,cardNum:res.data.data.idNumber});
                Toast.hide();
            }else{
                Toast.info(res.data.msg)
            }
        })
    };
    customRequest = (request) => {
        const { action, file, filename, fileSize, data, onProgress, onSuccess, onError } = request
        console.log(request);
        idcardUpload(data).then((res)=>{
            console.log(res);
            if(res.data.code == "0000"){
                this.setState({sfzzUrl:res.data.data.url});
                Toast.hide();
            }else{
                Toast.info(res.data.msg)
            }
        })
    };
    onClose = () => {
        this.setState({walletModal:false});
    };
    render(){
        const uploaderProps = {
            data:{
                source:1,
                token:this.props.userInfo.token,
                data:{imageType:0,file:this.state.fileData},
            },
            // accept:'.jpg',
            // capture:'camera',
            size:'1024',
            beforeUpload:this.beforeUpload,
            onStart: this.onStart,
            customRequest:this.renxiangCustom,
        };
        const sfzConfig = {
            data:{
                source:1,
                token:this.props.userInfo.token,
                data:{imageType:1,file:this.state.fileData},
            },
            // accept:'.jpg',
            size:'1024',
            // capture:'camera',
            // transformFile:this.transformFile,
            beforeUpload:this.beforeUpload,
            onStart: this.onStart,
            // onSuccess:this.sfzSuccess,
            customRequest:this.customRequest,
            onProgress(step, file) {
                console.log('onProgress', Math.round(step.percent), file.name);
            },
            onError(err) {
                console.log('onError', err);
            },
        };
        return(
            <div className="wallet">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >开通账户</NavBar>
                <div className="content">
                    <div className="top">
                        <div className="title">身份证信息采集</div>
                        <div className="sfz sfzz">
                            <div className="sfzDiv">
                                <p>身份证<span>人像</span>面</p>
                                <div>上传您的身份证人像面</div>
                            </div>
                            <div className="sfzImg">
                                <Upload
                                    capture="camera"
                                    {...uploaderProps}
                                    id="test"
                                    component="div"
                                    style={{ display: 'inline-block' }}
                                >
                                    <img src={this.state.imageUrl == "" ? sfzz : this.state.imageUrl} />
                                </Upload>
                            </div>
                        </div>
                        <div className="sfz">
                            <div className="sfzDiv">
                                <p>身份证<span>国徽</span>面</p>
                                <div>上传您的身份证国徽面</div>
                            </div>
                            <div className="sfzImg">
                                <Upload
                                    {...sfzConfig}
                                    id="test"
                                    component="div"
                                    style={{ display: 'inline-block' }}
                                >
                                    <img src={this.state.sfzzUrl == "" ? sfzf : this.state.sfzzUrl} />
                                </Upload>
                            </div>
                        </div>
                        <div className="title">个人信息</div>
                        <div className="list">
                            <InputItem
                                type="text"
                                disabled={this.state.dataFlag}
                                // maxLength={1}
                                className="inp"
                                placeholder="请输入姓名"
                                value={this.state.userName}
                                onChange={this.inputChange("userName")}
                                onBlur={v => window.scroll(0,0)}
                            >客户姓名</InputItem>
                        </div>
                        <div className="list">
                            <InputItem
                                type="text"
                                className="inp"
                                disabled={this.state.dataFlag}
                                placeholder="请输入证件号码"
                                value={this.state.cardNum}
                                onChange={this.inputChange("cardNum")}
                                onBlur={v => window.scroll(0,0)}
                            >证件号码</InputItem>
                        </div>
                        <div className="list">
                            <InputItem
                                type="number"
                                className="inp"
                                disabled={this.state.dataFlag}
                                placeholder="请输入银行卡号"
                                value={this.state.bankCard}
                                onChange={this.inputChange("bankCard")}
                                onBlur={v => window.scroll(0,0)}
                            >银行卡号</InputItem>
                        </div>
                        {/*<div className="tishi">
                            <p>只能绑定持卡人为本人的银行卡；</p>
                            <p>目前仅支持绑定以下银行发行的储蓄卡：</p>
                            <p>中国建设银行、中国工商银行、中国农业银行、中国邮政储蓄银行、交通银行、中国银行。</p>
                        </div>*/}
                        <div className="list" >
                            <InputItem
                                maxLength={11}
                                type="number"
                                className="inp"
                                disabled={this.state.dataFlag}
                                placeholder="请输入手机号码"
                                value={this.state.phone}
                                onChange={this.inputChange("phone")}
                                onBlur={v => window.scroll(0,0)}
                            >手机号码</InputItem>
                        </div>
                        <Picker
                            disabled={this.state.dataFlag}
                            data={colors}
                            value={this.state.occupation}
                            cols={1}
                            onChange={this.inputChange("occupation")}
                        >
                            <List.Item arrow="horizontal" className="start">从事职业</List.Item>
                        </Picker>
                        <div className="list">
                            <InputItem
                                clear
                                type="number"
                                maxLength={6}
                                placeholder="请输入验证码"
                                value={this.state.code}
                                onChange={this.inputChange('code')}
                                onBlur={v => window.scroll(0,0)}
                                extra={
                                    <button
                                        style={this.state.getCodeDisabled ? {color:"#fff",border:"none"}:null}
                                        disabled={this.state.getCodeDisabled}
                                        onClick={()=>this.getCode()}
                                    >{this.state.getCodeText}</button>
                                }
                            >
                                短信验证
                            </InputItem>
                        </div>
                        {/*<div className="list">
                            证件是否长期有效
                            {this.state.validity.map((res, i) => (
                                <Radio className="my-radio" key={i} checked={this.state.validityVal === res.value}
                                       onChange={() => this.setState({validityVal: res.value})}>
                                    {res.label}
                                </Radio>
                            ))}
                        </div>
                        <DatePicker
                            title="选择日期"
                            // minDate={new Date(+now + 7200000)}
                            minDate={new Date(now)}
                            cols={4}
                            mode="datetime"
                            value={this.state.date}
                            onChange={date => this.setState({ date })}
                            onOk={(v) =>this.changeTime(v, 'date')}
                        >
                            <List.Item arrow="horizontal" className="start" >证件签发日期</List.Item>
                        </DatePicker>*/}

                    </div>
                    <div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)} checked={this.state.protocolVal}>
                            <div onClick={() => this.setState({walletModal:true})}>《民途账户开通协议》</div>
                        </CheckboxItem>
                    </div>
                    {/*<Button disabled type="primary" onClick={()=>this.submit()}>立即开通</Button>*/}
                    {this.state.accountData !== "" && this.state.code !== "" ?
                        <Button type="primary" onClick={()=>this.submit()}>立即开通</Button> :
                        <Button disabled type="primary" onClick={()=>this.submit()}>立即开通</Button>
                    }

                </div>
                <WalletModal
                    modal={this.state.walletModal}
                    onClose={this.onClose.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/index.js